import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { EventModel } from "./EventModel";

export class EventFindResultModel extends BaseFindResult {

    public getDataItem(i: number): EventModel {
        let o: EventModel = Object.assign(new EventModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): EventModel[] {

        let d: EventModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: EventModel = Object.assign(new EventModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
